const translations = require('../../assets/configs/babel/de.json')
const _ = require('lodash')

const tmpBabel = require('../tmpBabel.json')

// sometimes webpacker in production doesn't rebuild babel
const forceRebuildToken = require('../forceBabelRebuild')

window.__localization = {
  locale: 'de',
  translations: _.merge({}, {de: tmpBabel["en"]}, translations)
}
